import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminMessagingComponent } from './admin-messaging.component';

const routes: Routes = [
  {
    path: '',
    component: AdminMessagingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminMessagingRoutingModule {}
